export default __webpack_public_path__ + "static/media/aboutimg5.81a9adef.webp";